module.exports = __webpack_public_path__ + "img/dsci0118.fc6fe8cd.jpg";